import { Link } from '@inertiajs/react';
import { HelpCircle } from 'lucide-react';

import { Button } from '../../components/ui/Button';

export const FaqBanner = () => {
    return (
        <div className="border-y bg-muted/30" data-testid="faq-banner">
            <div className="container flex flex-col items-center justify-center gap-3 py-6 text-center">
                <div className="rounded-full border bg-background p-2 shadow-sm">
                    <HelpCircle className="h-5 w-5 text-primary" />
                </div>

                <div className="space-y-1">
                    <h3 className="text-lg font-semibold">
                        Не знаєте як купити чи продати?
                    </h3>
                    <p className="max-w-[500px] text-sm text-muted-foreground">
                        Ми підготували детальну інструкцію для покупців та
                        продавців. Дізнайтеся, як безпечно проводити угоди на
                        CartOn.
                    </p>
                </div>

                <Button asChild variant="default" size="sm" className="mt-1">
                    <Link href="/faq">Читайте FAQ</Link>
                </Button>
            </div>
        </div>
    );
};
